import * as React from 'react';

import { FormFeedback, Input } from 'reactstrap';

import { GetSize } from '../../lib/utils';

import './FileUpload.scss';
import { acceptedExtensions } from '../../constants/file';

class FileUpload extends React.Component<FileUpload.IProps, FileUpload.IState> {
  render() {
    const disabled = !this.props.file || this.props.disabled;

    return (
      <div className="mt-5">
        <div className="position-relative">
          <Input
            type="file"
            name="file"
            id="file"
            accept={this.props.accepts || acceptedExtensions}
            onChange={this.props.FileChange}
            invalid={this.props.invalidFile}
            className={`file-upload pl-0 ${this.props.file ? 'd-none' : 'c-pointer'} ${this.props.invalidFile ? 'is-field-error' : ''}`}
          />
          <FormFeedback tooltip>{this.props.errorFeedback}</FormFeedback>
          <div className={`bg-white file-upload text-center ${!this.props.file ? 'c-pointer' : 'disabled'}`}>
            <span className={`eon-icon mt-4 ${this.props.file ? 'csv-icon disabled' : 'upload eon-red'}`} />
            <p className="eon-title eon-middle-grey mt-4 strong">{this.props.file && this.props.file.name}</p>
            <p
              className="eon-title eon-middle-grey mt-4 wrap-pre-line">{this.props.file ? this._getFileSize() : this.props.dragMessage}</p>
          </div>
        </div>
        <div className="mt-3 w-25 pr-4 d-flex flex-wrap">
          <p
            className={`eon-title eon-middle-grey text-nowrap text-center w-100 c-pointer ${!this.props.file ? 'd-none' : ''}`}
            onClick={this.props.RemoveFile}
          >
            {this.props.deleteButton}
          </p>
          <button className={`mt-4 eon-button bg-eon-red eon-white`} onClick={this.props.DoUploadFile}
                  disabled={disabled}>
            <span className="px-4 text-nowrap">{this.props.uploadButton}</span>
          </button>
        </div>
      </div>
    );
  }

  _getFileSize = () => GetSize(this.props.file);
}

export default FileUpload;
